export enum WorkingArea {
	Unknown = 0,
	/**
	 * High value working areas
	 */
	'TV & Film' = 1,
	Advertising = 2,
	'Brands & Business' = 3,
	/**
	 * Low value working areas
	 */
	'Audio Entertainment' = 4,
	Games = 5,
	'Individual Creator' = 6,
	Other = 7,
}
